import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
               <p style={{ textAlign: "justify" }}>
Nanosoft is a software development company in Istanbul Turkey, which provides its customers with a full range of software services with a focus on web development, web design, mobile application development and software testing

          </p>
          <p style={{ textAlign: "justify" }}>
We strive to achieve the best results in all the fields we offer and at the highest level through a professional and specialized team working to combine his efforts, expertise and talents to be used to provide the best services and achieve the goals and objectives of customers where we provide our services to all countries of the world at prices studied to suit everyone
          </p>
          <p className="border-top mt-3 pt-4">Ouer services</p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> WebSites
            </li>
            <li className="about-activity">
              <ImPointRight /> Applications
   </li>
          </ul>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
